import { useCallback, useMemo, useState } from 'react';
import Bell01Icon from '@untitled-ui/icons-react/build/esm/Bell01';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';

import { usePopover } from 'src/hooks/use-popover';
import { notifications as initialNotifications } from './notifications';
import { NotificationsPopover } from './notifications-popover';
import { useTranslation } from 'react-i18next';
import { Man2Rounded, Man3Outlined, ShoppingBag, ShoppingBasket } from '@mui/icons-material';
import { paths } from 'src/paths';
import { useNavigate } from "react-router-dom";
import { useCart } from 'src/hooks/use-carts';


const useNotifications = () => {
  const [notifications, setNotifications] = useState(initialNotifications);
  const unread = useMemo(() => {
    return notifications.reduce((acc, notification) => acc + (notification.read ? 0 : 1), 0);
  }, [notifications]);

  const handleRemoveOne = useCallback((notificationId) => {
    setNotifications((prevState) => {
      return prevState.filter((notification) => notification.id !== notificationId);
    });
  }, []);

  const handleMarkAllAsRead = useCallback(() => {
    setNotifications((prevState) => {
      return prevState.map((notification) => ({
        ...notification,
        read: true
      }));
    });
  }, []);

  return {
    handleMarkAllAsRead,
    handleRemoveOne,
    notifications,
    unread
  };
};

export const NotificationsButton = () => {
  const { t } = useTranslation();
  const popover = usePopover();
  const { handleRemoveOne, handleMarkAllAsRead, notifications, unread } = useNotifications();
  const navigate = useNavigate();
  const { cartCount } = useCart();
  return (
    <>
      <Tooltip title={t("My Carts")}>
        <IconButton
          ref={popover.anchorRef}
          onClick={() => { navigate(paths.inv.product.myCarts) }}
        >
          <Badge
            color="error"
            badgeContent={cartCount}
          >
            <SvgIcon> 
              <ShoppingBasket />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      {/* <Tooltip title="Notifications">
        <IconButton
          ref={popover.anchorRef}
          onClick={popover.handleOpen}
        >
          <Badge
            color="error"
            badgeContent={unread}
          >
            <SvgIcon>
              <Bell01Icon />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip> */}
      {/* <NotificationsPopover
        anchorEl={popover.anchorRef.current}
        notifications={notifications}
        onClose={popover.handleClose}
        onMarkAllAsRead={handleMarkAllAsRead}
        onRemoveOne={handleRemoveOne}
        open={popover.open}
      /> */}
    </>
  );
};
